// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination";
import getColor from "@insite/mobius/utilities/getColor";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

myListsDetailsOptionsStyles.paginationGridItem = {
    width: 12,
    css: css`
        ${xScreen("lte", "md")} {
            justify-content: center;
        }
    `,
};
